<template>
  <div>
    <nav class="navbar navbar-dark bg-dark justify-content-between flex-nowrap flex-row">
      <div class="container">
        <template v-if="auth_user.loggedIn">
          <a href="#" class="navbar-brand float-left" @click.prevent="goHome">
            <img src="../assets/logo.png" style="width: 160px;  margin-bottom: 10px;">
          </a>
          <ul class="nav navbar-nav flex-row float-right text-center">
            <li>
              <div class="nav-item">
                <span title="profilo" class="av-link px-2 mx-2 material-icons">
                  account_circle
                </span>
                <span style="color: #aaa">{{firstName}} @ </span>
                <span style="color: #aaa">{{storeName}}</span>
              </div>
            </li>
            <li class="nav-item">
              <a class="nav-link px-2 mx-2" @click.prevent="signOut">Esci</a>
            </li>
          </ul>
        </template>
        <template v-else>
          <a href="/welcome" class="navbar-brand float-left">
            <img src="../assets/logo.png" style="width: 160px;  margin-bottom: 10px;">
          </a>
          <ul class="nav navbar-nav flex-row float-right text-center">
            <li class="nav-item">
              <router-link to="login" class="nav-link px-2 mx-2">Accedi</router-link>
            </li>
          </ul>
        </template>
      </div>
    </nav>
  </div>
</template>

<script>
  import { auth } from '../firebase/config.js';
  import { mapGetters } from 'vuex';

  export default {
    data() {
      return {
      }
    },
    beforeMount() {
      window.addEventListener("beforeunload", this.preventNav)
      this.$once("hook:beforeDestroy", () => {
        window.removeEventListener("beforeunload", this.preventNav);
      })
    },
    computed: {
      ...mapGetters({
        // map `this.auth_user` to `this.$store.getters.user`
        auth_user: "user",
      }),
      firstName() {
        console.log('auth_user: ', this.auth_user)
        return this.auth_user.displayName.split(" ")[0]
      },
      storeName() {
        return this.auth_user.storeName
      }
    },
    methods: {
      preventNav(event) {
        //if (!this.isEditing) return  //always prevent refresh, not only while editing
        event.preventDefault()
        event.returnValue = ""
      },
      goHome() {
        if(this.auth_user.loggedIn) {
        //if(this.sel_user.loggedIn) {
          console.log('routeBefore', this.$route)
          this.$router.push({ name: "user_profile" })
          console.log('routeAfter', this.$route)
        }
        else {
          this.$router.replace({ name: "login" })
        }
      },
      signOut() {
        auth.signOut()
        .then(() => {
          this.auth_user.loggedIn = false
          this.$router.replace({ name: "login" });
        })
      }
    }
  }
</script>